/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type consultAnExpert_item = {
    readonly isJewelry: boolean | null;
    readonly getCategoriesByLevel: ReadonlyArray<{
        readonly label: string | null;
    } | null> | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly convertedAmounts: {
                readonly USD: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "consultAnExpert_item";
};
export type consultAnExpert_item$data = consultAnExpert_item;
export type consultAnExpert_item$key = {
    readonly " $data"?: consultAnExpert_item$data;
    readonly " $fragmentRefs": FragmentRefs<"consultAnExpert_item">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "consultAnExpert_item"
};
(node as any).hash = 'e9d9d34957fd5ef562f1076549ac2e91';
export default node;
